import React from 'react'
import gql from 'graphql-tag'
import {useMutation} from '@apollo/react-hooks'
import {Button, notification} from 'antd'
import {DeleteOutlined} from '@ant-design/icons'

const deleteInviceLineMutation = gql`
  mutation DeleteServiceProviderInvoiceLineMutation($id: ID!, $bookingId: ID!) {
    DeleteServiceProviderInvoiceLine(id: $id, bookingId: $bookingId) {
      deletedId
    }
  }
`

interface Props {
  bookingId: string
  invoiceLineId: string
  refetch: () => void
}

function DeleteButton({bookingId, invoiceLineId, refetch}: Props) {
  const [deleteInvoiceLine, {loading}] = useMutation(deleteInviceLineMutation)

  function handleDelete() {
    deleteInvoiceLine({
      variables: {
        id: invoiceLineId,
        bookingId,
      }
    }).then(() => {
      notification.success({
        message: 'Fakturalinjen ble slettet',
      })
      refetch()
    }).catch(() => {
      notification.error({
        message: 'Kunne ikke slette fakturalinje',
        description: 'Fakturalinjen kunne ikke slettes. Forsøk på nytt eller kontakt EFKT.',
      })
    })
  }

  return (
    <Button
      size="small"
      icon={<DeleteOutlined />}
      disabled={loading}
      loading={loading}
      onClick={handleDelete}
    />
  )
}

export default DeleteButton
